import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

const isDev = process.env.NODE_ENV === 'development';
if (isDev) console.log('[INDEX] JavaScript is executing! NODE_ENV:', process.env.NODE_ENV);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (isDev) console.log('[INDEX] React root created');

// Only use StrictMode in development to avoid double-mounting issues in production
const AppWrapper = process.env.NODE_ENV === 'development' ? (
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
) : (
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

if (isDev) console.log('[INDEX] About to render React app...');
root.render(AppWrapper);
if (isDev) console.log('[INDEX] React app rendered');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
